import React from 'react';
import { useBrand } from '../../contexts/BrandContext';
import { useTheme } from '../../theme/useTheme';

interface BrandLogoProps {
  className?: string;
}

/**
 * Renders the brand logo or name.
 * For WhiteLabel resellers: shows their uploaded logo.
 *   - Uses logo_dark_url in dark mode if provided, falls back to logo_url.
 * For default novofon: shows the text logo.
 */
export const BrandLogo: React.FC<BrandLogoProps> = ({ className }) => {
  const { brand } = useBrand();
  const { isDarkMode } = useTheme();

  const logoUrl = isDarkMode && brand.logo_dark_url ? brand.logo_dark_url : brand.logo_url;

  if (logoUrl) {
    return <img src={logoUrl} alt={brand.brand_name} className={`h-8 w-auto ${className || ''}`} />;
  }

  return (
    <h1
      className={`relative flex items-baseline gap-0 text-xl sm:text-2xl font-bold font-display tracking-tight select-none ${className || ''}`}
    >
      <span className="logo-novofon">{brand.brand_name}</span>
      {!brand.is_whitelabel && (
        <span className="logo-badge ml-1.5 text-base sm:text-lg font-black tracking-wider">
          2.2
        </span>
      )}
    </h1>
  );
};
